/**
 * Contesto Sentry per gli errori HTTP di axios.
 *
 * Gli AxiosError "Request failed with status code 500" arrivano tutti con lo
 * stesso titolo: senza metodo, URL e status non si distingue un endpoint
 * dall'altro. Qui si ricavano tag e fingerprint dalla richiesta fallita,
 * senza query string, codici articolo/ordine o corpi di richiesta/risposta.
 */

/** Normalizza un URL API: toglie origine e query, sostituisce i segmenti con cifre. */
export function normalizeApiUrl(url, baseURL = "") {
    if (typeof url !== "string" || !url) return "unknown";
    let path = url;
    try {
        path = new URL(url, baseURL || "https://work.invalid").pathname;
    } catch (_) {
        path = url.split("?")[0];
    }
    return path
        .split("/")
        .map((segment) => (/\d/.test(segment) ? "{id}" : segment))
        .join("/");
}

/** Restituisce {method, url, status} per un AxiosError con risposta, altrimenti null. */
export function axiosFailureContext(error) {
    if (!error || error.name !== "AxiosError" || !error.config) return null;
    const status = error.response?.status;
    if (typeof status !== "number") return null;
    return {
        method: String(error.config.method || "get").toUpperCase(),
        url: normalizeApiUrl(error.config.url, error.config.baseURL),
        status,
    };
}

/** Applica tag e fingerprint all'evento Sentry; non fa nulla se non è un errore HTTP. */
export function tagAxiosFailure(event, error) {
    const context = axiosFailureContext(error);
    if (!context) return event;
    event.tags = {
        ...(event.tags || {}),
        "http.method": context.method,
        "http.url": context.url,
        "http.status": String(context.status),
    };
    event.fingerprint = ["axios-http-error", context.method, context.url, String(context.status)];
    return event;
}
